<template>
  <div class="navbar">
    <div class="links">
      <a
        v-for="(link, index) in links"
        class="resp"
        :key="index"
        @click.prevent="
          link == 'Guide'
            ? $router.push('/' + link)
            : $router.push('/Panel/' + link)
        "
        :href="'/Panel/' + link"
      >
        {{ lang.links[link] }}
      </a>
    </div>
    <div class="profile-group">
      <img
        src="../../assets/icons/notifications.svg"
        @click="$router.push('/Panel/Notifications')"
      />
      <div class="lang-container" @click="handleLang()">
        <img :src="require('../../assets/icons/' + state.lang + '-flag.svg')" />
      </div>
      <div class="user-profile">
        <div class="username-container">
          <!-- <div
            class="user-brief-name"
            v-if="state.userInfo.firstName || state.userInfo.lastName"
          >
            {{ state.userInfo.firstName[0] + state.userInfo.lastName[0] }}
          </div> -->
          <div class="user-fullname">
            {{
              state.userInfo.firstName
                ? state.userInfo.firstName + " " + state.userInfo.lastName
                : state.userInfo.email
                ? state.userInfo.email
                : state.userInfo.mobileNumber
            }}
          </div>
        </div>
        <div class="user-profile__btn" @click="dropOpen = !dropOpen">
          <inline-svg
            :class="{ 'open-icon': dropOpen }"
            :src="require('../../assets/icons/arrowdown.svg')"
            class="arrow-icon"
          />
        </div>

        <div
          class="dropdown"
          :style="{
            height: dropOpen ? 30 * (profileLinks.length + 1) + 'px' : '0px',
            opacity: 1,
          }"
        >
          <a
            v-for="(link, index) in profileLinks"
            :href="'/Panel' + link.path"
            @click.prevent="
              $router.push('/Panel' + link.path);
              dropOpen = false;
            "
            :key="index"
            class="access"
          >
            {{ lang.profileLinks[link.name] }}
          </a>
          <div class="access" @click="showExitModal = true">
            {{ lang.logout }}
          </div>
        </div>
      </div>
    </div>
    <ExitModal
      v-if="showExitModal"
      @modalToggle="
        showExitModal = false;
        dropOpen = false;
      "
    />
  </div>
</template>

<script>
import axios from "axios";

import ExitModal from "../Modals/ExitModal";
export default {
  name: "PanelNavbar",
  props: {},
  components: {
    ExitModal,
  },
  data() {
    return {
      lang: this.$languageDict().panelNavbar,
      dropOpen: false,
      showExitModal: false,
      links: ["Trade", "Exchange", "Guide"],
      profileLinks: [
        {
          name: "Dashboard",
          path: "/Dashboard",
        },
        {
          name: "Profile",
          path: "/Profile",
        },
        {
          name: "Wallets",
          path: "/Wallets",
        },
        {
          name: "Trade",
          path: "/Trade/TOMAN/BITCOIN",
        },
      ],
    };
  },
  // computed: {
  //     getLang() {
  //         return JSON.parse(localStorage.getItem('lang'))

  //     }
  // },
  // watch:{
  //     "getLang":function(){
  //         console.log('dsfsadf')
  //     }
  // },
  methods: {
    handleLang() {
      if (this.state.lang === "en") {
        this.state.lang = "fa";
        axios.defaults.headers.common["Accept-Language"] = "fa";
        this.state.language = "PERSIAN";
      } else {
        this.state.lang = "en";
        axios.defaults.headers.common["Accept-Language"] = "en";
        this.state.language = "ENGLISH";
      }
      localStorage.setItem("lang", this.state.lang);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.open-icon {
  transform: rotate(-180deg);
}
.dropdown {
  position: absolute;
  width: 100%;
  background: #162045;
  top: 100%;
  display: flex;
  padding: 0px 8px;
  flex-direction: column;
  transition: height 0.5s;
  height: 0px;
  opacity: 0;
  overflow: hidden;

  .access {
    color: #fcfcfc;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: clamp(13px, 1.4vw, 16px);
    height: 30px;
    min-height: 30px;
  }
  .access:hover {
    color: #ef07a0;
  }
}
.navbar {
  position: sticky;
  top: 0;
  padding: 17px clamp(10px, 1.5vw, 17px) 10px clamp(10px, 1.5vw, 17px);
  // background: transparent;
  width: 100%;
  display: flex;
  column-gap: 25px;
  z-index: 60;
  align-items: center;
  justify-content: space-between;
  background: rgba(2, 14, 56, 1);
}

.arrow-icon {
  fill: #fcfcfc;
  cursor: pointer;
  width: 14px;
  transition: transform 0.3s;
}

.links {
  max-width: 304px;
  display: flex;
  align-items: center;
  column-gap: 12px;
  justify-content: space-between;
  flex-grow: 1;
  font-size: clamp(15px, 1.6vw, 18px);
}
.links > a {
  color: #bdbdbd;
}

.lang-container {
  display: flex;
  align-items: center;
  padding: 0px 4px;
  background: #162045;
  border-radius: 4px;
  cursor: pointer;
}

.username-container {
  display: flex;
  column-gap: 6px;
  height: 100%;
  align-items: center;
}

.profile-group {
  min-height: 40px;
  display: flex;
  column-gap: 8px;
  direction: ltr !important;

  // max-width: 283px;
  // flex-grow: 1;
}

.user-profile {
  display: flex;
  align-items: center;
  background: #162045;
  border-radius: 4px;
  flex-grow: 1;
  justify-content: space-between;
  position: relative;
  direction: ltr !important;
  &__btn {
    padding: 7px;
    cursor: pointer;
  }
}

.user-fullname {
  color: #fcfcfc;
  padding-left: 4px;
  @media (max-width: 600px) {
    display: none;
  }
}

.user-brief-name {
  background: linear-gradient(
    225deg,
    #18d5ff -14.29%,
    #6e12b6 52.07%,
    #ff00a8 112.52%
  );
  border-radius: 4px 0px 0px 4px;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding: 0px 8px;
  height: 100%;
  font-size: clamp(15px, 1.6vw, 18px);
}
@media (max-width: 720px) {
  .resp {
    display: none;
  }
}
</style>
